// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.emppayrollpage-inline-1 {
  text-align: center;
}

.emppayrollpage-inline-2 {
  font-size: 32px;
  font-weight: 800;
  color: #4f46e5;
  margin-bottom: 4px;
}

.emppayrollpage-inline-3 {
  font-size: 12px;
  color: #94a3b8;
}

.emppayrollpage-inline-4 {
  display: flex;
  justify-content: center;
  gap: 24px;
  margin-top: 16px;
}

.emppayrollpage-inline-5 {
  font-size: 16px;
  font-weight: 700;
  color: #2563eb;
}

.emppayrollpage-inline-6 {
  font-size: 11px;
  color: #94a3b8;
}

.emppayrollpage-inline-7 {
  font-size: 16px;
  font-weight: 700;
  color: #ef4444;
}

.emppayrollpage-inline-8 {
  font-size: 11px;
  color: #94a3b8;
}

.emppayrollpage-inline-9 {
  margin-top: 16px;
}

.emppayrollpage-inline-10 {
  padding: 0;
}

.emppayrollpage-inline-11 {
  text-align: center;
  color: #94a3b8;
  padding: 30px;
}

.emppayrollpage-inline-12 {
  font-weight: 600;
}

.emppayrollpage-inline-13 {
  font-weight: 700;
  color: #4f46e5;
}

.emppayrollpage-inline-14 {
  font-size: 11px;
  padding: 4px 10px;
}

.emppayrollpage-inline-15 {
  padding: 0;
}

.emppayrollpage-inline-16 {
  text-align: center;
  color: #94a3b8;
  padding: 30px;
}

.emppayrollpage-inline-17 {
  font-family: monospace;
  font-size: 11px;
}

.emppayrollpage-inline-18 {
  font-weight: 600;
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/Employee/EmpPayrollPage.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".emppayrollpage-inline-1 {\n  text-align: center;\n}\n\n.emppayrollpage-inline-2 {\n  font-size: 32px;\n  font-weight: 800;\n  color: #4f46e5;\n  margin-bottom: 4px;\n}\n\n.emppayrollpage-inline-3 {\n  font-size: 12px;\n  color: #94a3b8;\n}\n\n.emppayrollpage-inline-4 {\n  display: flex;\n  justify-content: center;\n  gap: 24px;\n  margin-top: 16px;\n}\n\n.emppayrollpage-inline-5 {\n  font-size: 16px;\n  font-weight: 700;\n  color: #2563eb;\n}\n\n.emppayrollpage-inline-6 {\n  font-size: 11px;\n  color: #94a3b8;\n}\n\n.emppayrollpage-inline-7 {\n  font-size: 16px;\n  font-weight: 700;\n  color: #ef4444;\n}\n\n.emppayrollpage-inline-8 {\n  font-size: 11px;\n  color: #94a3b8;\n}\n\n.emppayrollpage-inline-9 {\n  margin-top: 16px;\n}\n\n.emppayrollpage-inline-10 {\n  padding: 0;\n}\n\n.emppayrollpage-inline-11 {\n  text-align: center;\n  color: #94a3b8;\n  padding: 30px;\n}\n\n.emppayrollpage-inline-12 {\n  font-weight: 600;\n}\n\n.emppayrollpage-inline-13 {\n  font-weight: 700;\n  color: #4f46e5;\n}\n\n.emppayrollpage-inline-14 {\n  font-size: 11px;\n  padding: 4px 10px;\n}\n\n.emppayrollpage-inline-15 {\n  padding: 0;\n}\n\n.emppayrollpage-inline-16 {\n  text-align: center;\n  color: #94a3b8;\n  padding: 30px;\n}\n\n.emppayrollpage-inline-17 {\n  font-family: monospace;\n  font-size: 11px;\n}\n\n.emppayrollpage-inline-18 {\n  font-weight: 600;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
